// ============================================================
// Enums
// ============================================================
export var UserRole;
(function (UserRole) {
    UserRole["DONOR"] = "donor";
    UserRole["RECIPIENT"] = "recipient";
    UserRole["ADMIN"] = "admin";
})(UserRole || (UserRole = {}));
export var UserStatus;
(function (UserStatus) {
    UserStatus["PENDING"] = "pending";
    UserStatus["APPROVED"] = "approved";
    UserStatus["REJECTED"] = "rejected";
    UserStatus["SUSPENDED"] = "suspended";
})(UserStatus || (UserStatus = {}));
export var OrgType;
(function (OrgType) {
    OrgType["COMPANY"] = "company";
    OrgType["FOUNDATION"] = "foundation";
    OrgType["NONPROFIT"] = "nonprofit";
    OrgType["SCHOOL"] = "school";
    OrgType["GOVERNMENT"] = "government";
    OrgType["OTHER"] = "other";
})(OrgType || (OrgType = {}));
export var ProjectStatus;
(function (ProjectStatus) {
    ProjectStatus["DRAFT"] = "draft";
    ProjectStatus["ACTIVE"] = "active";
    ProjectStatus["COMPLETED"] = "completed";
    ProjectStatus["CANCELLED"] = "cancelled";
})(ProjectStatus || (ProjectStatus = {}));
export var AskStatus;
(function (AskStatus) {
    AskStatus["OPEN"] = "open";
    AskStatus["PARTIALLY_FULFILLED"] = "partially_fulfilled";
    AskStatus["FULFILLED"] = "fulfilled";
    AskStatus["CANCELLED"] = "cancelled";
})(AskStatus || (AskStatus = {}));
export var SeedFormat;
(function (SeedFormat) {
    SeedFormat["BULK"] = "bulk";
    SeedFormat["PACKET"] = "packet";
    SeedFormat["BOTH"] = "both";
})(SeedFormat || (SeedFormat = {}));
export var SeedTreatment;
(function (SeedTreatment) {
    SeedTreatment["TREATED"] = "treated";
    SeedTreatment["UNTREATED"] = "untreated";
})(SeedTreatment || (SeedTreatment = {}));
export var MediaType;
(function (MediaType) {
    MediaType["IMAGE"] = "image";
    MediaType["DOCUMENT"] = "document";
})(MediaType || (MediaType = {}));
export var DonationStatus;
(function (DonationStatus) {
    DonationStatus["PLEDGED"] = "pledged";
    DonationStatus["SHIPPED"] = "shipped";
    DonationStatus["DELIVERED"] = "delivered";
    DonationStatus["RECEIVED"] = "received";
    DonationStatus["VERIFIED"] = "verified";
    DonationStatus["CANCELLED"] = "cancelled";
})(DonationStatus || (DonationStatus = {}));
/** @deprecated Use DonationStatus */
export const TransactionStatus = DonationStatus;
//# sourceMappingURL=marketplace.js.map